import React from "react"
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {useFeedbackTools} from "../../components/FeedbackTools";

import Page from "../Page";
import GroupsTable from "./GroupsTable";
import useDataTable from "../../components/DataTable/useDataTable";
import {useDeleteGroup, useGroupsQuery} from "./query";

import MDBox from "materialDashboard/components/MDBox";
import MDButton from "materialDashboard/components/MDButton";
import Card from "@mui/material/Card";
import {useAuth} from "../../auth/AuthProvider";


const Groups = () => {
    const {t} = useTranslation(['groups']);
    const navigate = useNavigate();
    const {workgroupAuthorization} = useAuth();

    const {fetchDataOptions, ...tableState} = useDataTable({dataTableId: "groups"});
    const {askConfirmation} = useFeedbackTools();

    const dataQuery = useGroupsQuery(fetchDataOptions);
    const deleteGroupMutation = useDeleteGroup();

    const handleDelete = async (id) => {
        const innerDeleteGroup = async () => {
            await deleteGroupMutation.mutateAsync(id);
        }
        await askConfirmation({
            title: t('deleteGroup'),
            description: t('deleteGroupConfirmation'),
            confirmationText: t('deleteGroup'),
            onConfirm: innerDeleteGroup
        });
    }

    return <Page path={"/groups"}>
        <MDBox mx={2}>
            <MDBox mb={2}>
                {
                    workgroupAuthorization.groups.create &&
                    <MDButton variant="gradient" color="info" onClick={() => navigate("/groups/new")}>
                        {t('newGroup')}
                    </MDButton>
                }
            </MDBox>
            <Card>
                <GroupsTable rows={dataQuery.data?.rows}
                             page_count={dataQuery.data?.page_count}
                             onDelete={handleDelete}
                             showRowColoring={true}
                             {...tableState}/>
            </Card>
        </MDBox>
    </Page>

}

export default Groups;